import type { ReactNode } from 'react';

/** Wide-tracked uppercase eyebrow label (brandbook motif). */
export function Eyebrow({ children, color = '#666666' }: { children: ReactNode; color?: string }) {
  return (
    <div
      style={{
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color,
      }}
    >
      {children}
    </div>
  );
}
